/**
 * SMS messaging consent — copy, URLs, and prompt helpers (Twilio / A2P 10DLC).
 * Consent language must appear next to the checkbox (not only on the linked terms page).
 */

export const SMS_MESSAGING_TERMS_URL =
  "https://topachieversplano.org/sms-messaging-terms-conditions/";

export const SMS_PRIVACY_POLICY_URL = "https://topachieversplano.org/privacy-policy/";

export const SMS_OPT_IN_BRAND_NAME = "Top Achievers Foundation";

export const SMS_OPT_IN_SOURCES = Object.freeze({
  SIGNUP: "signup",
  PROFILE_PROMPT: "profile_prompt",
  PROFILE: "profile",
});

/**
 * Session key: user chose "Remind me later" for the existing-user SMS prompt.
 * Cleared on logout so the next sign-in can prompt again (same tab).
 * Also cleared when the browser tab/session ends.
 */
export const SMS_OPT_IN_REMIND_LATER_SESSION_KEY = "smsOptInRemindLater";

/**
 * True when the signed-in Parent/Participant has a phone and has never recorded an SMS consent choice.
 * @param {object|null|undefined} userInfo
 */
export function needsSmsOptInPrompt(userInfo) {
  if (!userInfo || !userInfo._id) return false;
  const roles = Array.isArray(userInfo.roles)
    ? userInfo.roles
    : userInfo.role
      ? [userInfo.role]
      : [];
  const isMessagingAudience = roles.some((r) => r === "Parent" || r === "Participant");
  if (!isMessagingAudience) return false;
  const phone = userInfo.phone_number != null ? String(userInfo.phone_number).trim() : "";
  if (!phone || phone === "—") return false;
  if (userInfo.sms_opt_in === true || userInfo.sms_opt_in === false) return false;
  return true;
}

/**
 * @param {string} [userId]
 */
export function wasSmsOptInRemindLater(userId) {
  try {
    const id = userId != null ? String(userId).trim() : "";
    if (!id) return false;
    return sessionStorage.getItem(SMS_OPT_IN_REMIND_LATER_SESSION_KEY) === id;
  } catch {
    return false;
  }
}

/**
 * @param {string} [userId]
 */
export function setSmsOptInRemindLater(userId) {
  try {
    const id = userId != null ? String(userId).trim() : "";
    if (!id) return;
    sessionStorage.setItem(SMS_OPT_IN_REMIND_LATER_SESSION_KEY, id);
  } catch {
    /* ignore */
  }
}

export function clearSmsOptInRemindLater() {
  try {
    sessionStorage.removeItem(SMS_OPT_IN_REMIND_LATER_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
